import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, styled } from '@mui/system';
import { Button } from '@mui/base/Button';
import { Input as BaseInput, inputClasses } from '@mui/base/Input';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Input = React.forwardRef(function CustomInput(props, ref) {
  const { slots, width, ...other } = props;
  return (
    <BaseInput
      slots={{
        root: InputRoot,
        input: InputElement,
        ...slots,
      }}
      {...other}
      ref={ref}
      sx={{ width: width }}
    />
  );
});

Input.propTypes = {
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    textarea: PropTypes.elementType,
  }),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default function Mui_searchbar({handleEnter, search, setSearch, placeholder, loan, type, inputWidth}) {
  const [values, setValues] = React.useState({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });
  

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
      }}
    >
      <Input
        type={type}
        id="outlined-start-adornment"
        placeholder={placeholder}
        startAdornment={<InputAdornment><i className="pi pi-search" style={{ color: "#64748B" }} /></InputAdornment>}
        onKeyUp={(e) => handleEnter(e)}
        value={search}
        onChange={!loan?(e) => setSearch(e.target.value):setSearch}
        width={inputWidth}
      />
    </Box>
  );
}

const blue = {
  100: '#DAECFF',
  200: '#80BFFF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const green = {
  100 : '#E9F8F8',
  200 : '#D1E1E1',
  300 : '#B9CACA',
  400 : '#A1B3B3',
  500 : '#899C9C',
  600 : '#718585',
  700 : '#596E6E',
  800 : '#415757',
  900 : '#293F3F'
};

const InputRoot = styled('div')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  border-radius: 3px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
  };
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  width: 400px;



  &.${inputClasses.focused} {
    border-color: ${green[700]};
    box-shadow: 0 0 0 2px ${theme.palette.mode === 'dark' ? green[400] : green[400]};
  }

  &:hover {
    border-color: ${green[500]};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`,
);

const InputElement = styled('input')(
  ({ theme }) => `
  font-size: 16px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.5;
  flex-grow: 1;
  color: #64748B;
  background: inherit;
  border: none;
  border-radius: 3px;
  padding: 8px 12px;
  outline: 0;
  height: 30px;
  &::placeholder{
    color: #CBD5E1;
  }
`,
);

const InputAdornment = styled('div')`
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
